import { DatesAndAccupancy, HotelBookingDataDetails } from "./widget/state/index.types";

export const BuildSearchParams = (object: Record<string, string|number|undefined|Array<any>>)=>{
    const params = new URLSearchParams();
    Object.entries(object).forEach(([key, value]) => params.append(key, value as string));
    return params.toString();
}

export const BestPriceSorter = (a: HotelBookingDataDetails, b: HotelBookingDataDetails, datesAndAccupancy: DatesAndAccupancy)=>{

    const aCanAccommodate = CanAccommodateOccupancy(datesAndAccupancy.adultes, datesAndAccupancy.children, a.code_occupancy, a.code_children);
    const bCanAccommodate = CanAccommodateOccupancy(datesAndAccupancy.adultes, datesAndAccupancy.children, b.code_occupancy, b.code_children);

    // 1. Priorité aux chambres qui peuvent accommoder l'occupation
    if (aCanAccommodate && !bCanAccommodate) return -1;
    if (!aCanAccommodate && bCanAccommodate) return 1;

    // 2. Si les deux peuvent ou ne peuvent pas accommoder, trier par prix
    const aTtc = a.detailPrice.Ttc || 0;
    const bTtc = b.detailPrice.Ttc || 0;

    // Gérer le cas où le prix est 0
    if (aTtc === 0 && bTtc === 0) return 0;
    if (aTtc === 0) return 1;  // a va en bas
    if (bTtc === 0) return -1; // b va en bas

    if (aTtc !== bTtc && (aCanAccommodate || bCanAccommodate)) {
        return aTtc - bTtc; // Prix croissant
    }
    
    // Si les deux peuvent accommoder ou aucune ne peut, trier par score d'occupation
    const aScore = OccupancyScore(a, datesAndAccupancy);
    const bScore = OccupancyScore(b, datesAndAccupancy);

    return bScore - aScore;
}

export const CanAccommodateOccupancy = (requestedAdults: number, requestedChildren: number, engineAdults: number, engineChildren: number): boolean => {
    // Total engine capacity
    const totalEngineCapacity: number = engineAdults + engineChildren;

    // Total number of requested people
    const totalRequested: number = requestedAdults + requestedChildren;

    // Check if total capacity is sufficient
    if (totalRequested > totalEngineCapacity) {
        return false;
    }

    // Check if there's enough space for adults
    if (requestedAdults > engineAdults) {
        return false;
    }

    // Calculate how many adult spaces can be converted to children spaces
    const unusedAdultSpaces: number = engineAdults - requestedAdults;
    const availableChildrenSpaces: number = engineChildren + unusedAdultSpaces;

    // Check if we can accommodate all children
    return requestedChildren <= availableChildrenSpaces;
}

export const OccupancyScore = (bestprice: HotelBookingDataDetails, datesAndAccupancy: DatesAndAccupancy): number => {

    const roomAdults     = bestprice.code_occupancy;
    const roomChildren   = bestprice.code_children;
    const searchAdults   = datesAndAccupancy.adultes;
    const searchChildren = datesAndAccupancy.children;

    // Vérifier si la chambre peut accommoder la recherche de base
    // if (roomAdults < searchAdults) return -1;

    // Calculer le score basé sur la capacité totale
    // Plus la capacité est grande, plus le score sera élevé
    const baseScore = 1000; // Score de base pour une chambre valide
    const extraCapacityScore = (roomAdults - searchAdults) * 100 + (roomChildren - searchChildren) * 50;

    return baseScore + extraCapacityScore;
}

export const appendFormData = (
    formData: FormData, 
    key: string, 
    value: unknown
): void => {
    if (Array.isArray(value)) {
        value.forEach((item, index) => {
            const nestedKey = `${key}[${index}]`;
            appendFormData(formData, nestedKey, item);
        });
    } else {
        // Note: FormData.append() only accepts `string | Blob`, so we convert non-Blob values to string
        formData.append(key, value instanceof Blob ? value : String(value));
    }
};